import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useLazyContentMetadataGet = () => {
  const createResource = useCallback(({ contentId, skip }) => {
    if (skip || !contentId) return undefined;

    return `${MONOLITH_ORIGIN}/api/v3/content-document/${contentId}/metadata/`;
  }, []);

  return useLazyRestQuery(createResource);
};

export default useLazyContentMetadataGet;
